import { ChangeEvent, useCallback, useState } from "react"

import { SWAP_SLIPPAGE_THRESHOLD } from "#/shared/constants"

const useSwapSlippageInput = (
  setSlippage: (
    value: string,
    shouldValidate?: boolean,
  ) => Promise<string | void>,
) => {
  const [error, setError] = useState("")

  const inputChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value } = e.target
      const normalizedValue = value.trim()
      const isValidNumber = !Number.isNaN(+normalizedValue)
      const leadingZeroPattern = /^0\d+/

      if (normalizedValue === "") {
        setError("")
        setSlippage("")
        return
      }

      if (!isValidNumber || leadingZeroPattern.test(normalizedValue)) return

      const parsedNormalizedValue = +normalizedValue

      if (parsedNormalizedValue > 100 || parsedNormalizedValue === 0) {
        setError("Invalid slippage percentage")
      } else if (parsedNormalizedValue >= SWAP_SLIPPAGE_THRESHOLD) {
        setError("Slippage has been surpassed")
      } else {
        setError("")
      }

      setSlippage(normalizedValue)
    },
    [setSlippage],
  )

  return { onInputChange: inputChangeHandler, error }
}

export default useSwapSlippageInput
